import listSaga from './listSaga'

const categoriesSagas = [listSaga()]

export default categoriesSagas
